module.exports = __webpack_public_path__ + "img/lens-167-plus-08.2ef53c92.png";